export default __webpack_public_path__ + "static/media/2F350849-CCB0-4308-B38E-B92AA4E32405_1_105_c.65df54a3.jpeg";